import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

import type { NgTopologyConfiguration } from '@/app/topology';

export const OIDC_CLIENT_ID = 'Portal';

export const OIDC_SCOPES: readonly string[] = [
  'openid',
  'profile',
  'roles',
  'ems.portal',
  'ems.psap.caller.locate',
  'ems.psap.caller.start.video.chat',
  'ems.incident.collaboration',
  'ems.incident.close',
  'ems.incident.update',
  'ems.incident.video',
  'ems.progress.request.setState',
  'videoserver.media.consume',
  'eed.call.data',
  'eed.request.video',
  'eed.request.media',
  'identity.incident.share.token',
  'offline_access',
];

export function createUserManager(topology: NgTopologyConfiguration): UserManager {
  return new UserManager({
    authority: topology.identityServerUrl,
    client_id: OIDC_CLIENT_ID,
    response_type: 'code',
    scope: OIDC_SCOPES.join(' '),
    redirect_uri: `${window.location.origin}/authentication/login-callback`,
    post_logout_redirect_uri: topology.identityServerUrl,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: false,
  });
}
